export interface MenuItemLink {
    href: string;
    title: string;
}

export interface MenuItems {
    [key: string]: MenuItemLink;
}

const PRINCIPLES: MenuItems = {
    general: { href: '/our-principles?section=general', title: 'General Principles' },
    business: { href: '/our-principles?section=business', title: 'Business' },
    data: { href: '/our-principles?section=data', title: 'Data' },
    society: { href: '/our-principles?section=society', title: 'Society' },
    competition: { href: '/our-principles?section=competition', title: 'Competition' },
    ai: { href: '/our-principles?section=ai', title: 'Artificial Intelligence' },
    distribution: { href: '/our-principles?section=distribution', title: 'Product Distribution' }
};

const GOVERNANCE: MenuItems = {
    overview: { href: '/corporate-governance/overview', title: 'Overview' },
    directors: { href: '/corporate-governance/board-of-directors', title: 'Board of Directors' },
    diversity: { href: '/corporate-governance/board-diversity-matrix', title: 'Board Diversity Matrix' },

    /* management: { href: '/corporate-governance/management', title: 'Management' }, */
    keyDocuments: { href: '/corporate-governance/key-documents', title: 'Key Documents' },
    faqGovernance: { href: '/corporate-governance/faq', title: 'FAQ' },
    contactsGovernance: { href: '/corporate-governance/contacts', title: 'Contacts' }
};

const VIDEO: MenuItems = {
    videoConferences: { href: '/video/', title: 'Конференции и другие видео' },
    videoInvestors: { href: '/video/for-investors', title: 'Выступления для инвесторов' }
};

const PAGES = {
    principles: PRINCIPLES,
    governance: GOVERNANCE,
    video: VIDEO
};

export { PAGES };
